<template>
  <ModalWithBackdrop
    label="Começar tour"
    v-bind="$attrs"
    className="newMedicWelcome"
    @action="handleClose"
  >
    <h2 class="title">Parabéns! Seu consultório virtual foi inaugurado!</h2>
    <img :src="ilustWelcome" class="illustration" />
    <h2 class="subtitle">Vamos te apresentar seu espaço.</h2>
    <p class="description">
      Faça um pequeno tour em menos de 2 minutos pra se familiarizar com seu
      novo consultório.
    </p>
  </ModalWithBackdrop>
</template>
<script>
import { mapActions } from 'vuex';
import ModalWithBackdrop from '@/components/ModalWithBackdrop';
import ilustWelcome from '@/assets/ilustracao-boas-vindas.png';
export default {
  name: 'NewMedicWelcome',

  components: { ModalWithBackdrop },

  data: () => ({
    ilustWelcome,
  }),

  methods: {
    ...mapActions('dashboard', [
      'closeModals',
      'toggleModal',
      'provideOnboarding',
    ]),

    handleClose() {
      this.closeModals();
      this.provideOnboarding();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>

<style lang="scss">
@import './unscopedStyle.scss';
</style>
